

<div>
  <div>
    <h1 mat-dialog-title>Add Locations</h1>
  </div>
  @if (showMainView) {
    <div>
      <form [formGroup]="locationListFormGroup" novalidate (ngSubmit)="changeView()">
        <div mat-dialog-content>
          <mat-form-field>
            <textarea #message [attr.data-testid]="'locationList_textarea'"
              formControlName="locationListFormControl" matInput
            placeholder="Location List"></textarea>
            <mat-error> {{ errorMessage }} </mat-error>
          </mat-form-field>
        </div>
        <div mat-dialog-actions>
          <button type="button" class="button-color" mat-raised-button matTooltip="OK" (click)="cancel()">
            Cancel
          </button>
          <button type="button" class="button-color" mat-raised-button matTooltip="OK" (click)="addList()">
            Continue
          </button>
        </div>
      </form>
    </div>
  }
  @if (!showMainView) {
    <div>
      <div mat-dialog-content class="location-list-scroll">
        <emm-locations-search-field class="location-set-locations-search-field" label="Location" searchMode="query"
          selectionMode="multiple" (hasValidationError)="setTagExists($event)"
          (removedLocation)="removeLocation($event)" (selectedLocation)="selectLocation($event)"
          (tagsNotFoundEvent)="addTagsNotFound($event)" [listOfTags]="listOfTags" [allLocations]="allLocations">
        </emm-locations-search-field>
      </div>
      @if (tagsNotFound.length > 0) {
        <div class="not-found-container">
          <div class="not-found-left">The following location(s) were not found: </div>
          <div class="not-found-right not-found-scroll">
            @for (tag of tagsNotFound; track tag; let i = $index) {
              <span>{{ tag }}@if (i < tagsNotFound.length - 1) {
                <span>, </span>
              }</span>
            }
          </div>
        </div>
      }
      <div mat-dialog-actions>
        <button class="button-color" mat-raised-button matTooltip="Cancel" (click)="cancel()">
          Cancel
        </button>
        <button cdkFocusInitial class="button-color"
          [disabled]="locations.length === 0 || tagExists || (isReadOnly$ | async)" mat-raised-button
          matTooltip="Save" (click)="addLocations()">
          Ok
        </button>
      </div>
    </div>
  }
</div>
